import { props, state } from 'cerebral/tags'
import { set, when } from 'cerebral/operators'
import createSnackbar from 'modules/App/factories/createSnackbar'
import getAllNodes from 'modules/Node/actions/getAllNodes'
import searchMedia from 'modules/Media/chains/searchMedia'
import deselectNodesOnChange from 'modules/Node/chains/deselectNodesOnChange'

const isAffected = ({ path, props, state }) => {
  const userGroup = state.get('app.user.group.name')
  return props.payload.affectedGroups.findIndex(
    group => group === userGroup
  ) !== -1
    ? path.true()
    : path.false()
}

export default [
  when(
    state`app.user.id`,
    props`payload.userId`,
    (user, updatingUser) => user === updatingUser
  ),
  {
    true: [], // does not need to reload tree
    false: [
      isAffected,
      {
        true: [
          getAllNodes,
          {
            loaded: [
              createSnackbar({ key: 'bms.node.event.reloadNavigation' }),
              set(props`node.id`, props`payload.id`), // deselectNodesOnChange needs this
              deselectNodesOnChange,
              set(state`node.nodes`, props`nodes`),
              set(state`node.rebuildTree`, true)
            ]
          }
        ],
        false: [] // Is not affected
      },
      when(state`media.latestSearchCriteria`),
      {
        true: [
          set(props`query`, state`media.latestSearchCriteria`),
          ...searchMedia,
          createSnackbar({ key: 'reloadSearch' })
        ],
        false: []
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Socket/chains/nodeChanged.js